/* eslint-disable no-loss-of-precision */
import blank from '../Blank/blankData'

import Hair01 from '../Hair/Hair01'
import Hair118front from '../Hair/Hair118front'
import Hair144 from '../Hair/Hair144'
import Hair33front from '../Hair/Hair33front'
import Hair75front from '../Hair/Hair75front'
import Hair34 from '../Hair/Hair34'
import Hair55front from '../Hair/Hair55front'
import Hair02front from '../Hair/Hair02front'
import Hair119 from '../Hair/Hair119'
import Hair14front from '../Hair/Hair14front'
import Hair35 from '../Hair/Hair35'
import Hair56 from '../Hair/Hair56'
import Hair76front from '../Hair/Hair76front'
import Hair36 from '../Hair/Hair36'
import Hair03front from '../Hair/Hair03front'
import Hair11front from '../Hair/Hair11front'
import Hair15front from '../Hair/Hair15front'
import Hair37 from '../Hair/Hair37'
import Hair57front from '../Hair/Hair57front'
import Hair77front from '../Hair/Hair77front'
import Hair04 from '../Hair/Hair04'
import Hair120 from '../Hair/Hair120'
import Hair05 from '../Hair/Hair05'
import Hair121 from '../Hair/Hair121'
import Hair16front from '../Hair/Hair16front'
import Hair38front from '../Hair/Hair38front'
import Hair58front from '../Hair/Hair58front'
import Hair78front from '../Hair/Hair78front'
import Hair06 from '../Hair/Hair06'
import Hair122 from '../Hair/Hair122'
import Hair79 from '../Hair/Hair79'
import Hair123 from '../Hair/Hair123'
import Hair17front from '../Hair/Hair17front'
import Hair39front from '../Hair/Hair39front'
import Hair59front from '../Hair/Hair59front'
import Hair07front from '../Hair/Hair07front'
import Hair80front from '../Hair/Hair80front'
import Hair08 from '../Hair/Hair08'
import Hair124front from '../Hair/Hair124front'
import Hair18front from '../Hair/Hair18front'
import Hair40front from '../Hair/Hair40front'
import Hair60front from '../Hair/Hair60front'
import Hair125 from '../Hair/Hair125'
import Hair61 from '../Hair/Hair61'
import Hair81front from '../Hair/Hair81front'
import Hair09front from '../Hair/Hair09front'
import Hair126 from '../Hair/Hair126'
import Hair19front from '../Hair/Hair19front'
import Hair41front from '../Hair/Hair41front'
import Hair62 from '../Hair/Hair62'
import Hair82 from '../Hair/Hair82'
import Hair100 from '../Hair/Hair100'
import Hair20 from '../Hair/Hair20'
import Hair83 from '../Hair/Hair83'
import Hair101 from '../Hair/Hair101'
import Hair127front from '../Hair/Hair127front'
import Hair42front from '../Hair/Hair42front'
import Hair63front from '../Hair/Hair63front'
import Hair84 from '../Hair/Hair84'
import Hair102 from '../Hair/Hair102'
import Hair128 from '../Hair/Hair128'
import Hair85 from '../Hair/Hair85'
import Hair103 from '../Hair/Hair103'
import Hair129 from '../Hair/Hair129'
import Hair43front from '../Hair/Hair43front'
import Hair64front from '../Hair/Hair64front'
import Hair86 from '../Hair/Hair86'
import Hair104 from '../Hair/Hair104'
import Hair22front from '../Hair/Hair22front'
import Hair44 from '../Hair/Hair44'
import Hair87 from '../Hair/Hair87'
import Hair105 from '../Hair/Hair105'
import Hair12front from '../Hair/Hair12front'
import Hair65front from '../Hair/Hair65front'
import Hair88 from '../Hair/Hair88'
import Hair13 from '../Hair/Hair13'
import Hair23front from '../Hair/Hair23front'
import Hair45front from '../Hair/Hair45front'
import Hair89 from '../Hair/Hair89'
import Hair106front from '../Hair/Hair106front'
import Hair130 from '../Hair/Hair130'
import Hair23middle from '../Hair/Hair23middle'
import Hair66front from '../Hair/Hair66front'
import Hair90 from '../Hair/Hair90'
import Hair107 from '../Hair/Hair107'
import Hair46front from '../Hair/Hair46front'
import Hair91 from '../Hair/Hair91'
import Hair108 from '../Hair/Hair108'
import Hair131front from '../Hair/Hair131front'
import Hair24front from '../Hair/Hair24front'
import Hair67front from '../Hair/Hair67front'
import Hair92 from '../Hair/Hair92'
import Hair109 from '../Hair/Hair109'
import Hair132 from '../Hair/Hair132'
import Hair47front from '../Hair/Hair47front'
import Hair93 from '../Hair/Hair93'
import Hair25front from '../Hair/Hair25front'
import Hair68front from '../Hair/Hair68front'
import Hair94 from '../Hair/Hair94'
import Hair10front from '../Hair/Hair10front'
import Hair133front from '../Hair/Hair133front'
import Hair48front from '../Hair/Hair48front'
import Hair110 from '../Hair/Hair110'
import Hair134 from '../Hair/Hair134'
import Hair26front from '../Hair/Hair26front'
import Hair69front from '../Hair/Hair69front'
import Hair95front from '../Hair/Hair95front'
import Hair111 from '../Hair/Hair111'
import Hair135 from '../Hair/Hair135'
import Hair49front from '../Hair/Hair49front'
import Hair96 from '../Hair/Hair96'
import Hair136 from '../Hair/Hair136'
import Hair27front from '../Hair/Hair27front'
import Hair70front from '../Hair/Hair70front'
import Hair112front from '../Hair/Hair112front'
import Hair137 from '../Hair/Hair137'
import Hair28 from '../Hair/Hair28'
import Hair50front from '../Hair/Hair50front'
import Hair97front from '../Hair/Hair97front'
import Hair138 from '../Hair/Hair138'
import Hair29 from '../Hair/Hair29'
import Hair113front from '../Hair/Hair113front'
import Hair51front from '../Hair/Hair51front'
import Hair98front from '../Hair/Hair98front'
import Hair139front from '../Hair/Hair139front'
import Hair30front from '../Hair/Hair30front'
import Hair72front from '../Hair/Hair72front'
import Hair99 from '../Hair/Hair99'
import Hair114front from '../Hair/Hair114front'
import Hair140 from '../Hair/Hair140'
import Hair31 from '../Hair/Hair31'
import Hair52front from '../Hair/Hair52front'
import Hair115 from '../Hair/Hair115'
import Hair141 from '../Hair/Hair141'
import Hair53 from '../Hair/Hair53'
import Hair73front from '../Hair/Hair73front'
import Hair116 from '../Hair/Hair116'
import Hair142 from '../Hair/Hair142'
import Hair32front from '../Hair/Hair32front'
import Hair74 from '../Hair/Hair74'
import Hair117 from '../Hair/Hair117'
import Hair143 from '../Hair/Hair143'
import Hair54front from '../Hair/Hair54front'

const data = [
  blank,
  {
    id: 'Hair01',
    svg: Hair01,
    positioning: {
      pointNarrow: {
        y: 35.3699951171875,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 43.55162048339844,
        scaleX: 0.9,
      },
      pointWide: {
        y: 33.42283630371094,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 40.55364990234375,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 43.686431884765625,
        scaleX: 0.95,
      },
      roundWide: {
        y: 42.466522216796875,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 38.9151611328125,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 41.899810791015625,
        scaleX: 0.95,
      },
      squareWide: {
        y: 38.319549560546875,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair02',
    svg: Hair02front,
    positioning: {
      pointNarrow: {
        y: 54.99851989746094,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 60.23527526855469,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 55.644432067871094,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.77055358886719,
        scaleX: 0.95,
      },
      roundWide: {
        y: 53.46112060546875,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 58.539703369140625,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 56.35181427001953,
        scaleX: 1,
      },
      squareWide: {
        y: 51.81658935546875,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair03',
    svg: Hair03front,
    positioning: {
      pointNarrow: {
        y: 53.82929992675781,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 59.38059997558594,
        scaleX: 1,
      },
      pointWide: {
        y: 51.087127685546875,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 58.80548858642578,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.27400207519531,
        scaleX: 1,
      },
      roundWide: {
        y: 53.932830810546875,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 58.596717834472656,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 53.88611602783203,
        scaleX: 1,
      },
      squareWide: {
        y: 51.60035705566406,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair04',
    svg: Hair04,
    positioning: {
      pointNarrow: {
        y: 51.01115417480469,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 54.7579345703125,
        scaleX: 1,
      },
      pointWide: {
        y: 53.16456604003906,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 55.52667999267578,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 55.81849670410156,
        scaleX: 1,
      },
      roundWide: {
        y: 49.776954650878906,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 56.69237518310547,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 52.29071807861328,
        scaleX: 1,
      },
      squareWide: {
        y: 53.29637908935547,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair05',
    svg: Hair05,
    positioning: {
      pointNarrow: {
        y: 37.15899658203125,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 39.417022705078125,
        scaleX: 0.95,
      },
      pointWide: {
        y: 29.80780029296875,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 43.30107116699219,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 36.98539733886719,
        scaleX: 0.95,
      },
      roundWide: {
        y: 27.340736389160156,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 34.77385711669922,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 27.93523406982422,
        scaleX: 1,
      },
      squareWide: {
        y: 34.41261291503906,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair06',
    svg: Hair06,
    positioning: {
      pointNarrow: {
        y: 51.51885986328125,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 54.85737609863281,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50.91252136230469,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 55.19072723388672,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 52.186248779296875,
        scaleX: 0.95,
      },
      roundWide: {
        y: 51.89009094238281,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 53.752227783203125,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 51.8685302734375,
        scaleX: 1,
      },
      squareWide: {
        y: 51.51611328125,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair07',
    svg: Hair07front,
    positioning: {
      pointNarrow: {
        y: 52.25483703613281,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 57.978912353515625,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 58.363372802734375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 55.008758544921875,
        scaleX: 0.95,
      },
      roundWide: {
        y: 49.875640869140625,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 56.09827423095703,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 52.90901184082031,
        scaleX: 1,
      },
      squareWide: {
        y: 52.05226135253906,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair08',
    svg: Hair08,
    positioning: {
      pointNarrow: {
        y: 41.69920349121094,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 44.413238525390625,
        scaleX: 1,
      },
      pointWide: {
        y: 38.10353088378906,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 44.63671112060547,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 43.491668701171875,
        scaleX: 0.9,
      },
      roundWide: {
        y: 39.514862060546875,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 38.86304473876953,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 42.704368591308594,
        scaleX: 1,
      },
      squareWide: {
        y: 41.575904846191406,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair09',
    svg: Hair09front,
    positioning: {
      pointNarrow: {
        y: 57.230438232421875,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 58.13978576660156,
        scaleX: 0.85,
      },
      pointWide: {
        y: 50.90904998779297,
        scaleX: 1,
      },
      roundNarrow: {
        y: 58.35661315917969,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 52.66932678222656,
        scaleX: 0.85,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 56.06397247314453,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 57.57984161376953,
        scaleX: 0.9,
      },
      squareWide: {
        y: 52.156944274902344,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair100',
    svg: Hair100,
    positioning: {
      pointNarrow: {
        y: 53.76652526855469,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 52.975555419921875,
        scaleX: 1.1,
      },
      pointWide: {
        y: 52.553497314453125,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 54.318382263183594,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 52.31379699707031,
        scaleX: 1.1,
      },
      roundWide: {
        y: 50.14337158203125,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 52.57176208496094,
        scaleX: 1,
      },
      squareMedium: {
        y: 50.642433166503906,
        scaleX: 1.05,
      },
      squareWide: {
        y: 50.56996154785156,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair101',
    svg: Hair101,
    positioning: {
      pointNarrow: {
        y: 58.130401611328125,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 59.84217834472656,
        scaleX: 1.1,
      },
      pointWide: {
        y: 58.00037384033203,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 59.095802307128906,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 60.02827453613281,
        scaleX: 1.05,
      },
      roundWide: {
        y: 58.87974548339844,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 58.537811279296875,
        scaleX: 1,
      },
      squareMedium: {
        y: 60.218605041503906,
        scaleX: 1.05,
      },
      squareWide: {
        y: 60.544471740722656,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair102',
    svg: Hair102,
    positioning: {
      pointNarrow: {
        y: 53.70484924316406,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 49.19921875,
        scaleX: 0.9,
      },
      pointWide: {
        y: 51.828643798828125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 52.555381774902344,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 51.89080810546875,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.782752990722656,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50.358978271484375,
        scaleX: 0.95,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair103',
    svg: Hair103,
    positioning: {
      pointNarrow: {
        y: 39.872161865234375,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 39.96620178222656,
        scaleX: 1.05,
      },
      pointWide: {
        y: 40.00067138671875,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 41.19768524169922,
        scaleX: 1,
      },
      roundMedium: {
        y: 41.91847229003906,
        scaleX: 1.1,
      },
      roundWide: {
        y: 42.45732879638672,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 40.82905578613281,
        scaleX: 1,
      },
      squareMedium: {
        y: 40.55326843261719,
        scaleX: 1.05,
      },
      squareWide: {
        y: 42.3209228515625,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair104',
    svg: Hair104,
    positioning: {
      pointNarrow: {
        y: 51.211456298828125,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 52.85496520996094,
        scaleX: 1.1,
      },
      pointWide: {
        y: 53.200042724609375,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 52.644439697265625,
        scaleX: 1,
      },
      roundMedium: {
        y: 53.80316162109375,
        scaleX: 1.1,
      },
      roundWide: {
        y: 54.18904113769531,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 50.6004638671875,
        scaleX: 1,
      },
      squareMedium: {
        y: 53.682220458984375,
        scaleX: 1.1,
      },
      squareWide: {
        y: 52.05492401123047,
        scaleX: 1.35,
      },
    },
  },
  {
    id: 'Hair105',
    svg: Hair105,
    positioning: {
      pointNarrow: {
        y: 42.45051574707031,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 43.72264099121094,
        scaleX: 1.1,
      },
      pointWide: {
        y: 41.01811218261719,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 44.71544647216797,
        scaleX: 1,
      },
      roundMedium: {
        y: 42.93989562988281,
        scaleX: 1.05,
      },
      roundWide: {
        y: 42.69110107421875,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 40.654571533203125,
        scaleX: 1,
      },
      squareMedium: {
        y: 41.375732421875,
        scaleX: 1.05,
      },
      squareWide: {
        y: 43.14476776123047,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair106',
    svg: Hair106front,
    positioning: {
      pointNarrow: {
        y: 56.80180358886719,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 55.18568420410156,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 56.791587829589844,
        scaleX: 1,
      },
      roundMedium: {
        y: 58.22740173339844,
        scaleX: 1.1,
      },
      roundWide: {
        y: 51.492706298828125,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 56.132537841796875,
        scaleX: 1,
      },
      squareMedium: {
        y: 56.446067810058594,
        scaleX: 1.05,
      },
      squareWide: {
        y: 56.72822570800781,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair107',
    svg: Hair107,
    positioning: {
      pointNarrow: {
        y: 51.21986389160156,
        scaleX: 1,
      },
      pointMedium: {
        y: 50.243072509765625,
        scaleX: 1.15,
      },
      pointWide: {
        y: 49.08561706542969,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 55.82148742675781,
        scaleX: 1,
      },
      roundMedium: {
        y: 50.462005615234375,
        scaleX: 1.1,
      },
      roundWide: {
        y: 51.51868438720703,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 54.512237548828125,
        scaleX: 1,
      },
      squareMedium: {
        y: 50.95579528808594,
        scaleX: 1.1,
      },
      squareWide: {
        y: 49.942543029785156,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair108',
    svg: Hair108,
    positioning: {
      pointNarrow: {
        y: 52.440887451171875,
        scaleX: 1,
      },
      pointMedium: {
        y: 50.4490966796875,
        scaleX: 1.1,
      },
      pointWide: {
        y: 51.1429443359375,
        scaleX: 1.4,
      },
      roundNarrow: {
        y: 56.944183349609375,
        scaleX: 1,
      },
      roundMedium: {
        y: 53.43341064453125,
        scaleX: 1.1,
      },
      roundWide: {
        y: 50,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 56.88542175292969,
        scaleX: 1,
      },
      squareMedium: {
        y: 53.59455108642578,
        scaleX: 1.1,
      },
      squareWide: {
        y: 52.487396240234375,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair109',
    svg: Hair109,
    positioning: {
      pointNarrow: {
        y: 54.91339111328125,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 49.90138244628906,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 55.12593078613281,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 49.71246337890625,
        scaleX: 0.95,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.422447204589844,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50.742210388183594,
        scaleX: 0.9,
      },
      squareWide: {
        y: 50.09503936767578,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair10',
    svg: Hair10front,
    positioning: {
      pointNarrow: {
        y: 54.821746826171875,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 52.200714111328125,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 57.14043426513672,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 55.110931396484375,
        scaleX: 1,
      },
      roundWide: {
        y: 48.22949981689453,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 55.879852294921875,
        scaleX: 0.875,
      },
      squareMedium: {
        y: 53.866416931152344,
        scaleX: 1,
      },
      squareWide: {
        y: 51.38092041015625,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair110',
    svg: Hair110,
    positioning: {
      pointNarrow: {
        y: 60.03376770019531,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 59.7684326171875,
        scaleX: 1.05,
      },
      pointWide: {
        y: 60.28594970703125,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 59.82331085205078,
        scaleX: 1,
      },
      roundMedium: {
        y: 61.33003234863281,
        scaleX: 1.1,
      },
      roundWide: {
        y: 61.84260559082031,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 60.590293884277344,
        scaleX: 1,
      },
      squareMedium: {
        y: 62.021453857421875,
        scaleX: 1.05,
      },
      squareWide: {
        y: 62.03691864013672,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair111',
    svg: Hair111,
    positioning: {
      pointNarrow: {
        y: 58.58934020996094,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 55.72019958496094,
        scaleX: 1.1,
      },
      pointWide: {
        y: 56.62872314453125,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 59.276161193847656,
        scaleX: 1,
      },
      roundMedium: {
        y: 58.42048645019531,
        scaleX: 1.1,
      },
      roundWide: {
        y: 56.900596618652344,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 59.15532684326172,
        scaleX: 1,
      },
      squareMedium: {
        y: 60.6864013671875,
        scaleX: 1.1,
      },
      squareWide: {
        y: 58.94293212890625,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair112',
    svg: Hair112front,
    positioning: {
      pointNarrow: {
        y: 55.080841064453125,
        scaleX: 1.125,
      },
      pointMedium: {
        y: 53.70390319824219,
        scaleX: 1.15,
      },
      pointWide: {
        y: 58.46299743652344,
        scaleX: 1.25,
      },
      roundNarrow: {
        y: 55.918434143066406,
        scaleX: 1,
      },
      roundMedium: {
        y: 57.30126953125,
        scaleX: 1.15,
      },
      roundWide: {
        y: 52.395477294921875,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 57.46062469482422,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.48588562011719,
        scaleX: 1.2,
      },
      squareWide: {
        y: 53.213478088378906,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair113',
    svg: Hair113front,
    positioning: {
      pointNarrow: {
        y: 55.93013000488281,
        scaleX: 1,
      },
      pointMedium: {
        y: 57.06190490722656,
        scaleX: 1.1,
      },
      pointWide: {
        y: 55.724464416503906,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 57.20137023925781,
        scaleX: 1,
      },
      roundMedium: {
        y: 51.00482177734375,
        scaleX: 1.05,
      },
      roundWide: {
        y: 50.98957061767578,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 55.697052001953125,
        scaleX: 1,
      },
      squareMedium: {
        y: 52.382652282714844,
        scaleX: 1.1,
      },
      squareWide: {
        y: 52.100852966308594,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair114',
    svg: Hair114front,
    positioning: {
      pointNarrow: {
        y: 52.386932373046875,
        scaleX: 1,
      },
      pointMedium: {
        y: 51.70372009277344,
        scaleX: 1.05,
      },
      pointWide: {
        y: 49.660545349121094,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 56.0872802734375,
        scaleX: 1,
      },
      roundMedium: {
        y: 50,
        scaleX: 1,
      },
      roundWide: {
        y: 48.695556640625,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 50,
        scaleX: 1,
      },
      squareMedium: {
        y: 50,
        scaleX: 1,
      },
      squareWide: {
        y: 51.005638122558594,
        scaleX: 1.2,
      },
    },
  },
  {
    id: 'Hair115',
    svg: Hair115,
    positioning: {
      pointNarrow: {
        y: 56.953643798828125,
        scaleX: 1,
      },
      pointMedium: {
        y: 55.4942626953125,
        scaleX: 1.15,
      },
      pointWide: {
        y: 51.60008239746094,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 57.267478942871094,
        scaleX: 1,
      },
      roundMedium: {
        y: 54.5751953125,
        scaleX: 1.05,
      },
      roundWide: {
        y: 54.06312561035156,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 57.17241668701172,
        scaleX: 1,
      },
      squareMedium: {
        y: 57.42279815673828,
        scaleX: 1.05,
      },
      squareWide: {
        y: 51.96881103515625,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair116',
    svg: Hair116,
    positioning: {
      pointNarrow: {
        y: 53.45330810546875,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 51.32087707519531,
        scaleX: 0.9,
      },
      pointWide: {
        y: 50,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 59.04973602294922,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 51.94927978515625,
        scaleX: 0.9,
      },
      roundWide: {
        y: 50.13618469238281,
        scaleX: 1,
      },
      squareNarrow: {
        y: 53.23090362548828,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 50.00505828857422,
        scaleX: 0.9,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair117',
    svg: Hair117,
    positioning: {
      pointNarrow: {
        y: 58.2098388671875,
        scaleX: 1,
      },
      pointMedium: {
        y: 56.54216003417969,
        scaleX: 1.1,
      },
      pointWide: {
        y: 55.284515380859375,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 58.116432189941406,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 59.79804992675781,
        scaleX: 1.1,
      },
      roundWide: {
        y: 53.81249237060547,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 58.833526611328125,
        scaleX: 1,
      },
      squareMedium: {
        y: 58.79449462890625,
        scaleX: 1.05,
      },
      squareWide: {
        y: 55.311424255371094,
        scaleX: 1.2,
      },
    },
  },
  {
    id: 'Hair118',
    svg: Hair118front,
    positioning: {
      pointNarrow: {
        y: 50.055450439453125,
        scaleX: 1,
      },
      pointMedium: {
        y: 48.8988037109375,
        scaleX: 1.1,
      },
      pointWide: {
        y: 45.60353088378906,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 52.252906799316406,
        scaleX: 1,
      },
      roundMedium: {
        y: 48.50990295410156,
        scaleX: 1.1,
      },
      roundWide: {
        y: 43.788604736328125,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 49.352394104003906,
        scaleX: 1,
      },
      squareMedium: {
        y: 47.754249572753906,
        scaleX: 1.05,
      },
      squareWide: {
        y: 48.87910461425781,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair119',
    svg: Hair119,
    positioning: {
      pointNarrow: {
        y: 54.380218505859375,
        scaleX: 1,
      },
      pointMedium: {
        y: 55.49299621582031,
        scaleX: 1.1,
      },
      pointWide: {
        y: 52.28578186035156,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 55.13097381591797,
        scaleX: 1,
      },
      roundMedium: {
        y: 52.283447265625,
        scaleX: 1.1,
      },
      roundWide: {
        y: 53.48939514160156,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 54.197357177734375,
        scaleX: 1,
      },
      squareMedium: {
        y: 52.584930419921875,
        scaleX: 1.05,
      },
      squareWide: {
        y: 52.82417297363281,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair11',
    svg: Hair11front,
    positioning: {
      pointNarrow: {
        y: 55.29823303222656,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 54.50703430175781,
        scaleX: 1,
      },
      pointWide: {
        y: 55.943115234375,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 56.03400421142578,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 55.28556823730469,
        scaleX: 1,
      },
      roundWide: {
        y: 51.08537292480469,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 57.28889465332031,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50.40717315673828,
        scaleX: 1,
      },
      squareWide: {
        y: 54.13585662841797,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair120',
    svg: Hair120,
    positioning: {
      pointNarrow: {
        y: 56.04783630371094,
        scaleX: 1,
      },
      pointMedium: {
        y: 55.530555725097656,
        scaleX: 1.1,
      },
      pointWide: {
        y: 54.343017578125,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 57.84636688232422,
        scaleX: 1,
      },
      roundMedium: {
        y: 54.72784423828125,
        scaleX: 1.1,
      },
      roundWide: {
        y: 54.36344909667969,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 58.06072235107422,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.75336456298828,
        scaleX: 1.05,
      },
      squareWide: {
        y: 55.058616638183594,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair121',
    svg: Hair121,
    positioning: {
      pointNarrow: {
        y: 54.925994873046875,
        scaleX: 1,
      },
      pointMedium: {
        y: 53.04121398925781,
        scaleX: 1.1,
      },
      pointWide: {
        y: 51.14283752441406,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 55.000831604003906,
        scaleX: 1,
      },
      roundMedium: {
        y: 55.36279296875,
        scaleX: 1.1,
      },
      roundWide: {
        y: 52.37568664550781,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 55.715728759765625,
        scaleX: 1,
      },
      squareMedium: {
        y: 55.47430419921875,
        scaleX: 1.1,
      },
      squareWide: {
        y: 52.92333984375,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair122',
    svg: Hair122,
    positioning: {
      pointNarrow: {
        y: 55.88616943359375,
        scaleX: 1,
      },
      pointMedium: {
        y: 59.06800842285156,
        scaleX: 1.1,
      },
      pointWide: {
        y: 58.228759765625,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 58.13468933105469,
        scaleX: 1,
      },
      roundMedium: {
        y: 56.233551025390625,
        scaleX: 1.05,
      },
      roundWide: {
        y: 60.01048278808594,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 58.11017608642578,
        scaleX: 1,
      },
      squareMedium: {
        y: 56.12445831298828,
        scaleX: 1.1,
      },
      squareWide: {
        y: 56.96614074707031,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair123',
    svg: Hair123,
    positioning: {
      pointNarrow: {
        y: 55.31890869140625,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 57.802825927734375,
        scaleX: 1,
      },
      pointWide: {
        y: 53.38848114013672,
        scaleX: 0.95,
      },
      roundNarrow: {
        y: 58.086700439453125,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.15577697753906,
        scaleX: 1,
      },
      roundWide: {
        y: 52.72563171386719,
        scaleX: 1,
      },
      squareNarrow: {
        y: 57.53667449951172,
        scaleX: 1,
      },
      squareMedium: {
        y: 56.91608428955078,
        scaleX: 1,
      },
      squareWide: {
        y: 52.46278381347656,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair124',
    svg: Hair124front,
    positioning: {
      pointNarrow: {
        y: 65.07440185546875,
        scaleX: 1,
      },
      pointMedium: {
        y: 64.44596862792969,
        scaleX: 1.15,
      },
      pointWide: {
        y: 65.02886199951172,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 64.62396240234375,
        scaleX: 1,
      },
      roundMedium: {
        y: 64.714569091796875,
        scaleX: 1.15,
      },
      roundWide: {
        y: 63.46919250488281,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 62.630767822265625,
        scaleX: 1,
      },
      squareMedium: {
        y: 64.88951873779297,
        scaleX: 1.15,
      },
      squareWide: {
        y: 65.21775817871094,
        scaleX: 1.35,
      },
    },
  },
  {
    id: 'Hair125',
    svg: Hair125,
    positioning: {
      pointNarrow: {
        y: 59.100067138671875,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 59.59437561035156,
        scaleX: 1.1,
      },
      pointWide: {
        y: 58.644386291503906,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 59.89067840576172,
        scaleX: 1,
      },
      roundMedium: {
        y: 60.859405517578125,
        scaleX: 1.05,
      },
      roundWide: {
        y: 59.77848815917969,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 58.67694854736328,
        scaleX: 1,
      },
      squareMedium: {
        y: 59.19683837890625,
        scaleX: 1.05,
      },
      squareWide: {
        y: 60.36293029785156,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair126',
    svg: Hair126,
    positioning: {
      pointNarrow: {
        y: 56.505279541015625,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 54.1800537109375,
        scaleX: 1.1,
      },
      pointWide: {
        y: 53.2000732421875,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 54.13990020751953,
        scaleX: 1,
      },
      roundMedium: {
        y: 57.58332824707031,
        scaleX: 1.1,
      },
      roundWide: {
        y: 53.125587463378906,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 56.06182098388672,
        scaleX: 1,
      },
      squareMedium: {
        y: 53.7406005859375,
        scaleX: 1.1,
      },
      squareWide: {
        y: 53.4901123046875,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair127',
    svg: Hair127front,
    positioning: {
      pointNarrow: {
        y: 56.167999267578125,
        scaleX: 1,
      },
      pointMedium: {
        y: 58.17645263671875,
        scaleX: 1.05,
      },
      pointWide: {
        y: 56.171546936035156,
        scaleX: 1.25,
      },
      roundNarrow: {
        y: 55.48625183105469,
        scaleX: 1,
      },
      roundMedium: {
        y: 55.996429443359375,
        scaleX: 1.1,
      },
      roundWide: {
        y: 59.354644775390625,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 58.13520050048828,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.81941223144531,
        scaleX: 1.1,
      },
      squareWide: {
        y: 58.410179138183594,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair128',
    svg: Hair128,
    positioning: {
      pointNarrow: {
        y: 41.33967590332031,
        scaleX: 1,
      },
      pointMedium: {
        y: 43.939300537109375,
        scaleX: 1.1,
      },
      pointWide: {
        y: 43.15885925292969,
        scaleX: 1.4,
      },
      roundNarrow: {
        y: 42.191864013671875,
        scaleX: 1,
      },
      roundMedium: {
        y: 41.333526611328125,
        scaleX: 1.1,
      },
      roundWide: {
        y: 43.74017333984375,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 41.71015930175781,
        scaleX: 1,
      },
      squareMedium: {
        y: 44.60071563720703,
        scaleX: 1.1,
      },
      squareWide: {
        y: 43.864219665527344,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair129',
    svg: Hair129,
    positioning: {
      pointNarrow: {
        y: 81.094482421875,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 79.89907836914062,
        scaleX: 1.1,
      },
      pointWide: {
        y: 70.95980834960938,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 81.19043731689453,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 84.66517639160156,
        scaleX: 1.1,
      },
      roundWide: {
        y: 80.39508056640625,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 85.53176879882812,
        scaleX: 1,
      },
      squareMedium: {
        y: 79.35601043701172,
        scaleX: 1.1,
      },
      squareWide: {
        y: 80.13069915771484,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair12',
    svg: Hair12front,
    positioning: {
      pointNarrow: {
        y: 52.635589599609375,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 51.07283020019531,
        scaleX: 1,
      },
      pointWide: {
        y: 54,
        scaleX: 1.125,
      },
      roundNarrow: {
        y: 54.38835906982422,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 53.976287841796875,
        scaleX: 1,
      },
      roundWide: {
        y: 54,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 55.332366943359375,
        scaleX: 0.857,
      },
      squareMedium: {
        y: 54.035430908203125,
        scaleX: 0.95,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair13',
    svg: Hair13,
    positioning: {
      pointNarrow: {
        y: 34.14936828613281,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 28.710372924804688,
        scaleX: 1,
      },
      pointWide: {
        y: 30.073348999023438,
        scaleX: 1,
      },
      roundNarrow: {
        y: 39.2882080078125,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 32.2435302734375,
        scaleX: 1,
      },
      roundWide: {
        y: 32.317657470703125,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 35.866615295410156,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 34.74766540527344,
        scaleX: 1,
      },
      squareWide: {
        y: 27.654296875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair130',
    svg: Hair130,
    positioning: {
      pointNarrow: {
        y: 49.95677185058594,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 50.20759582519531,
        scaleX: 0.95,
      },
      pointWide: {
        y: 49.77143859863281,
        scaleX: 1,
      },
      roundNarrow: {
        y: 53.2745361328125,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 50.18629455566406,
        scaleX: 0.95,
      },
      roundWide: {
        y: 50.80018615722656,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 52.366477966308594,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 50.06090545654297,
        scaleX: 0.95,
      },
      squareWide: {
        y: 50.645111083984375,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair131',
    svg: Hair131front,
    positioning: {
      pointNarrow: {
        y: 53.312530517578125,
        scaleX: 1,
      },
      pointMedium: {
        y: 55.74853515625,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 57.67070007324219,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 50,
        scaleX: 1,
      },
      roundWide: {
        y: 50.675628662109375,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 54.7423095703125,
        scaleX: 1,
      },
      squareMedium: {
        y: 52.18360900878906,
        scaleX: 1,
      },
      squareWide: {
        y: 50.173858642578125,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair132',
    svg: Hair132,
    positioning: {
      pointNarrow: {
        y: 60.280487060546875,
        scaleX: 1,
      },
      pointMedium: {
        y: 59.58049011230469,
        scaleX: 1.1,
      },
      pointWide: {
        y: 60.41143798828125,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 60.34229278564453,
        scaleX: 1,
      },
      roundMedium: {
        y: 61.58570861816406,
        scaleX: 1.1,
      },
      roundWide: {
        y: 57.99851989746094,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 58.825767517089844,
        scaleX: 1,
      },
      squareMedium: {
        y: 57.97361755371094,
        scaleX: 1.1,
      },
      squareWide: {
        y: 59.011322021484375,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair133',
    svg: Hair133front,
    positioning: {
      pointNarrow: {
        y: 54.97645568847656,
        scaleX: 1,
      },
      pointMedium: {
        y: 52.033477783203125,
        scaleX: 1.1,
      },
      pointWide: {
        y: 55.80375671386719,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 54.84290313720703,
        scaleX: 1,
      },
      roundMedium: {
        y: 55.568634033203125,
        scaleX: 1.1,
      },
      roundWide: {
        y: 50.95470428466797,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 56.36163330078125,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.654273986816406,
        scaleX: 1.1,
      },
      squareWide: {
        y: 53.735504150390625,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair134',
    svg: Hair134,
    positioning: {
      pointNarrow: {
        y: 56.10491943359375,
        scaleX: 1,
      },
      pointMedium: {
        y: 53.26338195800781,
        scaleX: 1.1,
      },
      pointWide: {
        y: 52.743072509765625,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 57.93975830078125,
        scaleX: 1,
      },
      roundMedium: {
        y: 56.39353942871094,
        scaleX: 1.1,
      },
      roundWide: {
        y: 56.33580017089844,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 55.952659606933594,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.17554473876953,
        scaleX: 1.1,
      },
      squareWide: {
        y: 54.677940368652344,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair135',
    svg: Hair135,
    positioning: {
      pointNarrow: {
        y: 55.977783203125,
        scaleX: 1,
      },
      pointMedium: {
        y: 55.54383850097656,
        scaleX: 1.1,
      },
      pointWide: {
        y: 50,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 59.24018096923828,
        scaleX: 1,
      },
      roundMedium: {
        y: 56.962921142578125,
        scaleX: 1.1,
      },
      roundWide: {
        y: 57.15863037109375,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 54.93315887451172,
        scaleX: 1,
      },
      squareMedium: {
        y: 57.581321716308594,
        scaleX: 1.1,
      },
      squareWide: {
        y: 54.866249084472656,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair136',
    svg: Hair136,
    positioning: {
      pointNarrow: {
        y: 52.21403503417969,
        scaleX: 1,
      },
      pointMedium: {
        y: 50,
        scaleX: 1.1,
      },
      pointWide: {
        y: 51.78363037109375,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 56.44025421142578,
        scaleX: 1,
      },
      roundMedium: {
        y: 50.90440368652344,
        scaleX: 1.1,
      },
      roundWide: {
        y: 49.94956970214844,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 53.00221252441406,
        scaleX: 1,
      },
      squareMedium: {
        y: 51.736419677734375,
        scaleX: 1.1,
      },
      squareWide: {
        y: 51.659889221191406,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair137',
    svg: Hair137,
    positioning: {
      pointNarrow: {
        y: 51.890106201171875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 55.239105224609375,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 55.25775146484375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 51.77484130859375,
        scaleX: 0.95,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 55.06048583984375,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50,
        scaleX: 0.95,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair138',
    svg: Hair138,
    positioning: {
      pointNarrow: {
        y: 51.52503967285156,
        scaleX: 1,
      },
      pointMedium: {
        y: 55.13386535644531,
        scaleX: 1.05,
      },
      pointWide: {
        y: 49.621490478515625,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 56.46228790283203,
        scaleX: 1,
      },
      roundMedium: {
        y: 50.489959716796875,
        scaleX: 1.05,
      },
      roundWide: {
        y: 51.474578857421875,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 53.69776153564453,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.78965759277344,
        scaleX: 1.05,
      },
      squareWide: {
        y: 52.87147521972656,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair139',
    svg: Hair139front,
    positioning: {
      pointNarrow: {
        y: 59.07115173339844,
        scaleX: 1,
      },
      pointMedium: {
        y: 58.782135009765625,
        scaleX: 1,
      },
      pointWide: {
        y: 56.13130187988281,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 58.43898010253906,
        scaleX: 1,
      },
      roundMedium: {
        y: 58.33341979980469,
        scaleX: 1,
      },
      roundWide: {
        y: 56.69073486328125,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 57.03369140625,
        scaleX: 1,
      },
      squareMedium: {
        y: 56.981048583984375,
        scaleX: 1,
      },
      squareWide: {
        y: 59.52415466308594,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair140',
    svg: Hair140,
    positioning: {
      pointNarrow: {
        y: 50.19903564453125,
        scaleX: 1,
      },
      pointMedium: {
        y: 52.9539794921875,
        scaleX: 1.1,
      },
      pointWide: {
        y: 54.11442565917969,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 55.415740966796875,
        scaleX: 1,
      },
      roundMedium: {
        y: 50,
        scaleX: 1.1,
      },
      roundWide: {
        y: 53.051544189453125,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 50.488685607910156,
        scaleX: 1,
      },
      squareMedium: {
        y: 50,
        scaleX: 1.1,
      },
      squareWide: {
        y: 51.256263732910156,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair141',
    svg: Hair141,
    positioning: {
      pointNarrow: {
        y: 50.16017150878906,
        scaleX: 1,
      },
      pointMedium: {
        y: 49.141448974609375,
        scaleX: 1.1,
      },
      pointWide: {
        y: 45.93922424316406,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 48.97422790527344,
        scaleX: 1,
      },
      roundMedium: {
        y: 50,
        scaleX: 1.05,
      },
      roundWide: {
        y: 49.90007019042969,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 51.08953857421875,
        scaleX: 1,
      },
      squareMedium: {
        y: 50.418540954589844,
        scaleX: 1.05,
      },
      squareWide: {
        y: 51.96308135986328,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair142',
    svg: Hair142,
    positioning: {
      pointNarrow: {
        y: 56.406341552734375,
        scaleX: 1,
      },
      pointMedium: {
        y: 56.99200439453125,
        scaleX: 1.05,
      },
      pointWide: {
        y: 54.57152557373047,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 59.547523498535156,
        scaleX: 1,
      },
      roundMedium: {
        y: 56.658111572265625,
        scaleX: 1.05,
      },
      roundWide: {
        y: 54.853973388671875,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 58.21381378173828,
        scaleX: 1,
      },
      squareMedium: {
        y: 57.20158386230469,
        scaleX: 1.1,
      },
      squareWide: {
        y: 55.898468017578125,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair143',
    svg: Hair143,
    positioning: {
      pointNarrow: {
        y: 53.09797668457031,
        scaleX: 1,
      },
      pointMedium: {
        y: 56.15458679199219,
        scaleX: 1.1,
      },
      pointWide: {
        y: 51.37144470214844,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 54.815879821777344,
        scaleX: 1,
      },
      roundMedium: {
        y: 55.94306945800781,
        scaleX: 1.1,
      },
      roundWide: {
        y: 55.090057373046875,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 54.552215576171875,
        scaleX: 1,
      },
      squareMedium: {
        y: 55.71184539794922,
        scaleX: 1.1,
      },
      squareWide: {
        y: 52.683685302734375,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair144',
    svg: Hair144,
    positioning: {
      pointNarrow: {
        y: 48.01240539550781,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 50.637603759765625,
        scaleX: 0.9,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 53.17176818847656,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 50,
        scaleX: 0.9,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 51.13104248046875,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 50,
        scaleX: 0.9,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair14',
    svg: Hair14front,
    positioning: {
      pointNarrow: {
        y: 53.47239685058594,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 53.25776672363281,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 53.73090362548828,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 52.70111083984375,
        scaleX: 0.9,
      },
      roundWide: {
        y: 57.47821044921875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 53.614013671875,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 54.464691162109375,
        scaleX: 1,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair15',
    svg: Hair15front,
    positioning: {
      pointNarrow: {
        y: 52.50038146972656,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 52.70777893066406,
        scaleX: 0.95,
      },
      pointWide: {
        y: 49.31425476074219,
        scaleX: 1,
      },
      roundNarrow: {
        y: 59.3333740234375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.291229248046875,
        scaleX: 1,
      },
      roundWide: {
        y: 53.38722229003906,
        scaleX: 1,
      },
      squareNarrow: {
        y: 55.51347351074219,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 50.743133544921875,
        scaleX: 0.95,
      },
      squareWide: {
        y: 53.547607421875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair16',
    svg: Hair16front,
    positioning: {
      pointNarrow: {
        y: 52.559112548828125,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 56.46742248535156,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 56.321434020996094,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.630828857421875,
        scaleX: 1,
      },
      roundWide: {
        y: 57,
        scaleX: 1.125,
      },
      squareNarrow: {
        y: 53.97752380371094,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 50,
        scaleX: 0.95,
      },
      squareWide: {
        y: 57.24726867675781,
        scaleX: 1.125,
      },
    },
  },
  {
    id: 'Hair17',
    svg: Hair17front,
    positioning: {
      pointNarrow: {
        y: 52.63383483886719,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 51.726226806640625,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 52.35888671875,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 53.083892822265625,
        scaleX: 1,
      },
      roundWide: {
        y: 55.434722900390625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 53.81913757324219,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 51.8721923828125,
        scaleX: 1,
      },
      squareWide: {
        y: 56.26263427734375,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair18',
    svg: Hair18front,
    positioning: {
      pointNarrow: {
        y: 50,
        scaleX: 0.75,
        x: -3.0,
      },
      pointMedium: {
        y: 50,
        scaleX: 0.85,
        x: -3.2,
      },
      pointWide: {
        y: 53.41648864746094,
        scaleX: 1,
        x: -3.7,
      },
      roundNarrow: {
        y: 53.152748107910156,
        scaleX: 0.75,
        x: -3.0,
      },
      roundMedium: {
        y: 50.78294372558594,
        scaleX: 0.9,
        x: -3.4,
      },
      roundWide: {
        y: 52.29853820800781,
        scaleX: 1,
        x: -3.7,
      },
      squareNarrow: {
        y: 50.535972595214844,
        scaleX: 0.8,
        x: -3.0,
      },
      squareMedium: {
        y: 49.95488739013672,
        scaleX: 0.85,
        x: -3.2,
      },
      squareWide: {
        y: 51.20936584472656,
        scaleX: 1,
        x: -3.7,
      },
    },
  },
  {
    id: 'Hair19',
    svg: Hair19front,
    positioning: {
      pointNarrow: {
        y: 55.83843994140625,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 52.46368408203125,
        scaleX: 0.95,
      },
      pointWide: {
        y: 46.28472137451172,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 54.50914764404297,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 51.703857421875,
        scaleX: 0.95,
      },
      roundWide: {
        y: 49.25433349609375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 54.13328552246094,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 50,
        scaleX: 0.85,
      },
      squareWide: {
        y: 49.35615539550781,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair20',
    svg: Hair20,
    positioning: {
      pointNarrow: {
        y: 56.60298156738281,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 57.75395202636719,
        scaleX: 1,
      },
      pointWide: {
        y: 52.13475036621094,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 58.012245178222656,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.96955871582031,
        scaleX: 1,
      },
      roundWide: {
        y: 55.67494201660156,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 53.127845764160156,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.491539001464844,
        scaleX: 1.05,
      },
      squareWide: {
        y: 51.044456481933594,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair22',
    svg: Hair22front,
    positioning: {
      pointNarrow: {
        y: 53.00146484375,
        scaleX: 1,
      },
      pointMedium: {
        y: 52.60414123535156,
        scaleX: 0.95,
      },
      pointWide: {
        y: 46.09185791015625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 55.15076446533203,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 57.441429138183594,
        scaleX: 1,
      },
      roundWide: {
        y: 48.37860870361328,
        scaleX: 1,
      },
      squareNarrow: {
        y: 50.7755126953125,
        scaleX: 1,
      },
      squareMedium: {
        y: 56.72688293457031,
        scaleX: 1,
      },
      squareWide: {
        y: 54.67884063720703,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair23',
    svg: Hair23front,
    positioning: {
      pointNarrow: {
        y: 34.0682373046875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 35.01177978515625,
        scaleX: 1,
      },
      pointWide: {
        y: 35.88349914550781,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 33.90888977050781,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 30.19231414794922,
        scaleX: 0.95,
      },
      roundWide: {
        y: 30.268325805664062,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 34.6182861328125,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 30.63603973388672,
        scaleX: 1,
      },
      squareWide: {
        y: 32.201576232910156,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair23middle',
    svg: Hair23middle,
    positioning: {
      pointNarrow: {
        y: 57.39630126953125,
        scaleX: 1,
      },
      pointMedium: {
        y: 56.25732421875,
        scaleX: 1,
      },
      pointWide: {
        y: 48.93414306640625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 57.47047424316406,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 58.046974182128906,
        scaleX: 1,
      },
      roundWide: {
        y: 56.24134826660156,
        scaleX: 1,
      },
      squareNarrow: {
        y: 56.51786804199219,
        scaleX: 1,
      },
      squareMedium: {
        y: 56.09077453613281,
        scaleX: 1,
      },
      squareWide: {
        y: 54.69761657714844,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair24',
    svg: Hair24front,
    positioning: {
      pointNarrow: {
        y: 51.35188293457031,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 51.34925079345703,
        scaleX: 0.85,
      },
      pointWide: {
        y: 49.90950012207031,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 50.52272033691406,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 54.61405944824219,
        scaleX: 0.85,
      },
      roundWide: {
        y: 49.73167419433594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.409515380859375,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 54.2152099609375,
        scaleX: 0.85,
      },
      squareWide: {
        y: 48.88109588623047,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair25',
    svg: Hair25front,
    positioning: {
      pointNarrow: {
        y: 49.82612609863281,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 50.36029052734375,
        scaleX: 0.85,
      },
      pointWide: {
        y: 47.81098175048828,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 50.333465576171875,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 51.12372589111328,
        scaleX: 0.9,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 50,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 48.987266540527344,
        scaleX: 0.9,
      },
      squareWide: {
        y: 47.56889343261719,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair26',
    svg: Hair26front,
    positioning: {
      pointNarrow: {
        y: 49.66084289550781,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 50.84844970703125,
        scaleX: 0.85,
      },
      pointWide: {
        y: 52.432037353515625,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 50.09364318847656,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 50,
        scaleX: 0.85,
      },
      roundWide: {
        y: 48.294830322265625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 51.40178680419922,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 53.325523376464844,
        scaleX: 0.85,
      },
      squareWide: {
        y: 51.714744567871094,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair27',
    svg: Hair27front,
    positioning: {
      pointNarrow: {
        y: 54.45329284667969,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 59.17070007324219,
        scaleX: 0.85,
      },
      pointWide: {
        y: 59.26795959472656,
        scaleX: 1,
      },
      roundNarrow: {
        y: 60.113250732421875,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 55.30242919921875,
        scaleX: 0.85,
      },
      roundWide: {
        y: 59.267913818359375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 57.84131622314453,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 54.56867218017578,
        scaleX: 0.9,
      },
      squareWide: {
        y: 53.70344543457031,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair28',
    svg: Hair28,
    positioning: {
      pointNarrow: {
        y: 47.60283660888672,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 49.359580993652344,
        scaleX: 0.95,
      },
      pointWide: {
        y: 44.13441467285156,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 50.803916931152344,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 48.253273010253906,
        scaleX: 0.85,
      },
      roundWide: {
        y: 47.247047424316406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 49.62095642089844,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 49.49701690673828,
        scaleX: 0.9,
      },
      squareWide: {
        y: 46.86051940917969,
        scaleX: 0.95,
      },
    },
  },
  {
    id: 'Hair29',
    svg: Hair29,
    positioning: {
      pointNarrow: {
        y: 54.5540771484375,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 53.66783142089844,
        scaleX: 0.95,
      },
      pointWide: {
        y: 46.216064453125,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 55.55433654785156,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.426063537597656,
        scaleX: 1,
      },
      roundWide: {
        y: 50.95391845703125,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 52.865203857421875,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 54.40361785888672,
        scaleX: 1,
      },
      squareWide: {
        y: 53.51952362060547,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair30',
    svg: Hair30front,
    positioning: {
      pointNarrow: {
        y: 56.543853759765625,
        scaleX: 1,
      },
      pointMedium: {
        y: 58.29241180419922,
        scaleX: 1,
      },
      pointWide: {
        y: 46.3624267578125,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 59.31810760498047,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.33026123046875,
        scaleX: 1,
      },
      roundWide: {
        y: 54.57548522949219,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 56.69667053222656,
        scaleX: 1,
      },
      squareMedium: {
        y: 53.82415771484375,
        scaleX: 1,
      },
      squareWide: {
        y: 50.95732879638672,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair31',
    svg: Hair31,
    positioning: {
      pointNarrow: {
        y: 49.46623229980469,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 50.32472229003906,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50.04460906982422,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 53.09196472167969,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 49.35917663574219,
        scaleX: 0.9,
      },
      roundWide: {
        y: 53.07978820800781,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 50.919593811035156,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 48.06053161621094,
        scaleX: 0.9,
      },
      squareWide: {
        y: 45.07916259765625,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair32',
    svg: Hair32front,
    positioning: {
      pointNarrow: {
        y: 56.92796325683594,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 54.85686492919922,
        scaleX: 1,
      },
      pointWide: {
        y: 53.60420227050781,
        scaleX: 1,
      },
      roundNarrow: {
        y: 55.53303527832031,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 55.350730895996094,
        scaleX: 1,
      },
      roundWide: {
        y: 56.74842834472656,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 58.211952209472656,
        scaleX: 1,
      },
      squareMedium: {
        y: 57.46668243408203,
        scaleX: 1,
      },
      squareWide: {
        y: 53.27758026123047,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair33',
    svg: Hair33front,
    positioning: {
      pointNarrow: {
        y: 50,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 50,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 52.478363037109375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.76293182373047,
        scaleX: 0.95,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 53.04656219482422,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50,
        scaleX: 1,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair34',
    svg: Hair34,
    positioning: {
      pointNarrow: {
        y: 49.76861572265625,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 54.28498840332031,
        scaleX: 1,
      },
      pointWide: {
        y: 51.017974853515625,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 53.41184997558594,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.53282928466797,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.456748962402344,
        scaleX: 1,
      },
      squareMedium: {
        y: 50,
        scaleX: 1,
      },
      squareWide: {
        y: 50.845985412597656,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair35',
    svg: Hair35,
    positioning: {
      pointNarrow: {
        y: 36.011932373046875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 40.41038131713867,
        scaleX: 0.95,
      },
      pointWide: {
        y: 31.171951293945312,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 43.9284782409668,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 36.3477783203125,
        scaleX: 0.9,
      },
      roundWide: {
        y: 43.83941650390625,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 41.801048278808594,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 43.604095458984375,
        scaleX: 0.9,
      },
      squareWide: {
        y: 32.54588317871094,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair36',
    svg: Hair36,
    positioning: {
      pointNarrow: {
        y: 43.39884948730469,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 46.271385192871094,
        scaleX: 0.9,
      },
      pointWide: {
        y: 42.046630859375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 46.741851806640625,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 44.57892608642578,
        scaleX: 0.85,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 44.426727294921875,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 44.63581848144531,
        scaleX: 0.9,
      },
      squareWide: {
        y: 41.720184326171875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair37',
    svg: Hair37,
    positioning: {
      pointNarrow: {
        y: 43.65142822265625,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 40.323646545410156,
        scaleX: 0.95,
      },
      pointWide: {
        y: 31.70599365234375,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 41.805625915527344,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 35.56226348876953,
        scaleX: 0.95,
      },
      roundWide: {
        y: 44.96138000488281,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 40.470855712890625,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 38.234962463378906,
        scaleX: 0.95,
      },
      squareWide: {
        y: 29.364288330078125,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair38',
    svg: Hair38front,
    positioning: {
      pointNarrow: {
        y: 48.91056823730469,
        scaleX: 1,
      },
      pointMedium: {
        y: 52.751190185546875,
        scaleX: 0.9,
      },
      pointWide: {
        y: 45.28260040283203,
        scaleX: 1,
      },
      roundNarrow: {
        y: 50.837013244628906,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 51.43120574951172,
        scaleX: 1,
      },
      roundWide: {
        y: 47.40679931640625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.19048309326172,
        scaleX: 1,
      },
      squareMedium: {
        y: 51.67839813232422,
        scaleX: 0.95,
      },
      squareWide: {
        y: 44.008567810058594,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair39',
    svg: Hair39front,
    positioning: {
      pointNarrow: {
        y: 56.021270751953125,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 59.31903839111328,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 54.256744384765625,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 56.566131591796875,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 56.30229949951172,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 50,
        scaleX: 1,
      },
      squareWide: {
        y: 50.51673889160156,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair40',
    svg: Hair40front,
    positioning: {
      pointNarrow: {
        y: 53.87083435058594,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 52.908226013183594,
        scaleX: 0.95,
      },
      pointWide: {
        y: 42.577362060546875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 51.91455841064453,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.61314392089844,
        scaleX: 1,
      },
      roundWide: {
        y: 50.04563903808594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 55.744483947753906,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 52.70648956298828,
        scaleX: 1,
      },
      squareWide: {
        y: 51.64326477050781,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair41',
    svg: Hair41front,
    positioning: {
      pointNarrow: {
        y: 53.821441650390625,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 58.379722595214844,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 54.417137145996094,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 54.069496154785156,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 56.76603698730469,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50,
        scaleX: 1,
      },
      squareWide: {
        y: 51.887413024902344,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair42',
    svg: Hair42front,
    positioning: {
      pointNarrow: {
        y: 55.27366638183594,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 54.42265319824219,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 53.99579620361328,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.07335662841797,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 56.13087463378906,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50,
        scaleX: 1,
      },
      squareWide: {
        y: 49.4393310546875,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair43',
    svg: Hair43front,
    positioning: {
      pointNarrow: {
        y: 57.49102783203125,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 56.56336975097656,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 55.78843688964844,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 57.598472595214844,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 58.83367919921875,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 53.827049255371094,
        scaleX: 1,
      },
      squareWide: {
        y: 54.235511779785156,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair44',
    svg: Hair44,
    positioning: {
      pointNarrow: {
        y: 51.076263427734375,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 51.967994689941406,
        scaleX: 1,
      },
      pointWide: {
        y: 39.0718994140625,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 51.770263671875,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 49.83873748779297,
        scaleX: 1,
      },
      roundWide: {
        y: 50.610565185546875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 51.95081329345703,
        scaleX: 1,
      },
      squareMedium: {
        y: 47.380332946777344,
        scaleX: 1,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair45',
    svg: Hair45front,
    positioning: {
      pointNarrow: {
        y: 50,
        scaleX: 0.75,
        x: 2.5,
      },
      pointMedium: {
        y: 51.22106170654297,
        scaleX: 0.85,
        x: 3.0,
      },
      pointWide: {
        y: 50.28057861328125,
        scaleX: 1,
        x: 3.0,
      },
      roundNarrow: {
        y: 50.925140380859375,
        scaleX: 0.75,
        x: 2.5,
      },
      roundMedium: {
        y: 50,
        scaleX: 0.85,
        x: 3.0,
      },
      roundWide: {
        y: 52.585601806640625,
        scaleX: 1,
        x: 3.0,
      },
      squareNarrow: {
        y: 51.02880096435547,
        scaleX: 0.75,
        x: 2.5,
      },
      squareMedium: {
        y: 48.87178039550781,
        scaleX: 0.85,
        x: 3.0,
      },
      squareWide: {
        y: 49.57427978515625,
        scaleX: 1.05,
        x: 3.0,
      },
    },
  },
  {
    id: 'Hair46',
    svg: Hair46front,
    positioning: {
      pointNarrow: {
        y: 55.44952392578125,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 58.640419006347656,
        scaleX: 1,
      },
      pointWide: {
        y: 44.11949157714844,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 56.36621856689453,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 55.10509490966797,
        scaleX: 1,
      },
      roundWide: {
        y: 53.46183776855469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 53.319793701171875,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 53.180938720703125,
        scaleX: 1,
      },
      squareWide: {
        y: 52.719261169433594,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair47',
    svg: Hair47front,
    positioning: {
      pointNarrow: {
        y: 53.46485900878906,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 52.645263671875,
        scaleX: 1,
      },
      pointWide: {
        y: 40.644901275634766,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 55.482994079589844,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 51.35847473144531,
        scaleX: 1,
      },
      roundWide: {
        y: 48.80332946777344,
        scaleX: 1,
      },
      squareNarrow: {
        y: 53.67936706542969,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 51.59425354003906,
        scaleX: 1,
      },
      squareWide: {
        y: 50.202056884765625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair48',
    svg: Hair48front,
    positioning: {
      pointNarrow: {
        y: 50.357269287109375,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 57.14384460449219,
        scaleX: 1,
      },
      pointWide: {
        y: 47.87385177612305,
        scaleX: 1,
      },
      roundNarrow: {
        y: 53.503746032714844,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.50890350341797,
        scaleX: 1,
      },
      roundWide: {
        y: 51.12664794921875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.59770965576172,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 51.943634033203125,
        scaleX: 1,
      },
      squareWide: {
        y: 51.70574188232422,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair49',
    svg: Hair49front,
    positioning: {
      pointNarrow: {
        y: 50.795623779296875,
        scaleX: 0.8,
        x: 4.5,
      },
      pointMedium: {
        y: 53.082435607910156,
        scaleX: 0.9,
        x: 3.0,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
        x: 3.0,
      },
      roundNarrow: {
        y: 56.00444030761719,
        scaleX: 0.8,
        x: 4.5,
      },
      roundMedium: {
        y: 50,
        scaleX: 0.9,
        x: 3.0,
      },
      roundWide: {
        y: 51.65582275390625,
        scaleX: 1,
        x: 3.0,
      },
      squareNarrow: {
        y: 52.410118103027344,
        scaleX: 0.8,
        x: 3.5,
      },
      squareMedium: {
        y: 50,
        scaleX: 0.9,
        x: 3.0,
      },
      squareWide: {
        y: 50,
        scaleX: 1,
        x: 3.0,
      },
    },
  },
  {
    id: 'Hair50',
    svg: Hair50front,
    positioning: {
      pointNarrow: {
        y: 39.309814453125,
        scaleX: 1,
      },
      pointMedium: {
        y: 43.54972839355469,
        scaleX: 1,
      },
      pointWide: {
        y: 28.00798797607422,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 40.671470642089844,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 36.44427490234375,
        scaleX: 1,
      },
      roundWide: {
        y: 33.850128173828125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 38.92437744140625,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 35.97254943847656,
        scaleX: 1,
      },
      squareWide: {
        y: 36.63828659057617,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair51',
    svg: Hair51front,
    positioning: {
      pointNarrow: {
        y: 55.69244384765625,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 59.780616760253906,
        scaleX: 1,
      },
      pointWide: {
        y: 44.317352294921875,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 55.739219665527344,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 51.369171142578125,
        scaleX: 1,
      },
      roundWide: {
        y: 43.273284912109375,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 53.06848907470703,
        scaleX: 1,
      },
      squareMedium: {
        y: 49.84010314941406,
        scaleX: 1,
      },
      squareWide: {
        y: 52.31987762451172,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair52',
    svg: Hair52front,
    positioning: {
      pointNarrow: {
        y: 53.89190673828125,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 57.670692443847656,
        scaleX: 1,
      },
      pointWide: {
        y: 44.20585632324219,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 54.19892883300781,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 52.703826904296875,
        scaleX: 1,
      },
      roundWide: {
        y: 55.77838134765625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 55.31519317626953,
        scaleX: 1,
      },
      squareMedium: {
        y: 53.816314697265625,
        scaleX: 1,
      },
      squareWide: {
        y: 50.30933380126953,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair53',
    svg: Hair53,
    positioning: {
      pointNarrow: {
        y: 45.21531677246094,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 50.06988525390625,
        scaleX: 1,
      },
      pointWide: {
        y: 44.31529235839844,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 48.96430969238281,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 44.758888244628906,
        scaleX: 0.95,
      },
      roundWide: {
        y: 42.107177734375,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 47.94041442871094,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 47.84583282470703,
        scaleX: 0.9,
      },
      squareWide: {
        y: 45.06263732910156,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair54',
    svg: Hair54front,
    positioning: {
      pointNarrow: {
        y: 52.3193359375,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 54.54682159423828,
        scaleX: 0.9,
      },
      pointWide: {
        y: 48.763153076171875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 52.887786865234375,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 51.68171691894531,
        scaleX: 0.85,
      },
      roundWide: {
        y: 50.19941711425781,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.26417541503906,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 50.33158874511719,
        scaleX: 0.85,
      },
      squareWide: {
        y: 52.202415466308594,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair55',
    svg: Hair55front,
    positioning: {
      pointNarrow: {
        y: 55.49104309082031,
        scaleX: 1,
      },
      pointMedium: {
        y: 57.204505920410156,
        scaleX: 1,
      },
      pointWide: {
        y: 49.58354187011719,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 54.476715087890625,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 55.31000518798828,
        scaleX: 0.95,
      },
      roundWide: {
        y: 55.68254089355469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 54.13300323486328,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.853729248046875,
        scaleX: 0.95,
      },
      squareWide: {
        y: 50.48625183105469,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair56',
    svg: Hair56,
    positioning: {
      pointNarrow: {
        y: 56.35865783691406,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 57.12793731689453,
        scaleX: 1,
      },
      pointWide: {
        y: 50.68809509277344,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 55.99842071533203,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.42332458496094,
        scaleX: 1,
      },
      roundWide: {
        y: 55.28944396972656,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 55.52552032470703,
        scaleX: 1,
      },
      squareMedium: {
        y: 55.60038757324219,
        scaleX: 1,
      },
      squareWide: {
        y: 49.43244171142578,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair57',
    svg: Hair57front,
    positioning: {
      pointNarrow: {
        y: 57.10877990722656,
        scaleX: 0.875,
      },
      pointMedium: {
        y: 52.964622497558594,
        scaleX: 1,
      },
      pointWide: {
        y: 54,
        scaleX: 1.2,
      },
      roundNarrow: {
        y: 57.63311004638672,
        scaleX: 0.875,
      },
      roundMedium: {
        y: 56.93939208984375,
        scaleX: 1,
      },
      roundWide: {
        y: 50.152442932128906,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 54.744590759277344,
        scaleX: 1,
      },
      squareMedium: {
        y: 53.359619140625,
        scaleX: 1.05,
      },
      squareWide: {
        y: 51.12287139892578,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair58',
    svg: Hair58front,
    positioning: {
      pointNarrow: {
        y: 57.41998291015625,
        scaleX: 0.875,
      },
      pointMedium: {
        y: 53.60060119628906,
        scaleX: 1,
      },
      pointWide: {
        y: 53,
        scaleX: 1.2,
      },
      roundNarrow: {
        y: 57.42658996582031,
        scaleX: 0.875,
      },
      roundMedium: {
        y: 56.603248596191406,
        scaleX: 1,
      },
      roundWide: {
        y: 50.4180908203125,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 57.84557342529297,
        scaleX: 1,
      },
      squareMedium: {
        y: 52.977439880371094,
        scaleX: 1.05,
      },
      squareWide: {
        y: 52.39844512939453,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair59',
    svg: Hair59front,
    positioning: {
      pointNarrow: {
        y: 57.32569885253906,
        scaleX: 1,
      },
      pointMedium: {
        y: 54.023109436035156,
        scaleX: 1,
      },
      pointWide: {
        y: 51.29804992675781,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 57.262489318847656,
        scaleX: 1,
      },
      roundMedium: {
        y: 58.207122802734375,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 56.130638122558594,
        scaleX: 1,
      },
      squareMedium: {
        y: 54.15705108642578,
        scaleX: 1,
      },
      squareWide: {
        y: 50.14292907714844,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair60',
    svg: Hair60front,
    positioning: {
      pointNarrow: {
        y: 55.41374206542969,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 54.91167449951172,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 57.24010467529297,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.403961181640625,
        scaleX: 1,
      },
      roundWide: {
        y: 55.34098815917969,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 52.77330017089844,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 53.59447479248047,
        scaleX: 1,
      },
      squareWide: {
        y: 50.62974548339844,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair61',
    svg: Hair61,
    positioning: {
      pointNarrow: {
        y: 35.67240905761719,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 36.71788024902344,
        scaleX: 1,
      },
      pointWide: {
        y: 29.965415954589844,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 37.961456298828125,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 32.73212432861328,
        scaleX: 1,
      },
      roundWide: {
        y: 36.16033935546875,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 33.438926696777344,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 30.53881072998047,
        scaleX: 0.95,
      },
      squareWide: {
        y: 35.03007507324219,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair62',
    svg: Hair62,
    positioning: {
      pointNarrow: {
        y: 36.6556396484375,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 41.79106140136719,
        scaleX: 1,
      },
      pointWide: {
        y: 37.307456970214844,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 40.75140380859375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 37.77220916748047,
        scaleX: 1,
      },
      roundWide: {
        y: 40.07554626464844,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 36.650909423828125,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 36.545021057128906,
        scaleX: 1,
      },
      squareWide: {
        y: 40.105865478515625,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair63',
    svg: Hair63front,
    positioning: {
      pointNarrow: {
        y: 52.6790771484375,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 55.658905029296875,
        scaleX: 1,
      },
      pointWide: {
        y: 51.98851013183594,
        scaleX: 1,
      },
      roundNarrow: {
        y: 56.867958068847656,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 52.42670440673828,
        scaleX: 0.95,
      },
      roundWide: {
        y: 51.770355224609375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 54.51636505126953,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 53.69902801513672,
        scaleX: 1,
      },
      squareWide: {
        y: 51.888511657714844,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair64',
    svg: Hair64front,
    positioning: {
      pointNarrow: {
        y: 50.47196960449219,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 53.03917694091797,
        scaleX: 1,
      },
      pointWide: {
        y: 45.305564880371094,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 54.39967346191406,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 51.19166564941406,
        scaleX: 1,
      },
      roundWide: {
        y: 52.88352966308594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.88458251953125,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 51.45259094238281,
        scaleX: 1,
      },
      squareWide: {
        y: 50.57820129394531,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair65',
    svg: Hair65front,
    positioning: {
      pointNarrow: {
        y: 55.29118347167969,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 56.74684143066406,
        scaleX: 1,
      },
      pointWide: {
        y: 52.61895751953125,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 56.939308166503906,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.75250244140625,
        scaleX: 1,
      },
      roundWide: {
        y: 54.871612548828125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 58.024078369140625,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 56.07360076904297,
        scaleX: 1,
      },
      squareWide: {
        y: 53.11577606201172,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair66',
    svg: Hair66front,
    positioning: {
      pointNarrow: {
        y: 51.26213073730469,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 58.261253356933594,
        scaleX: 1,
      },
      pointWide: {
        y: 45.18379211425781,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 60.50322723388672,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 55.951934814453125,
        scaleX: 1,
      },
      roundWide: {
        y: 50.26203918457031,
        scaleX: 1,
      },
      squareNarrow: {
        y: 59.04924011230469,
        scaleX: 1,
      },
      squareMedium: {
        y: 49.57377624511719,
        scaleX: 1.05,
      },
      squareWide: {
        y: 52.524085998535156,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair67',
    svg: Hair67front,
    positioning: {
      pointNarrow: {
        y: 42.31474304199219,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 45.00144958496094,
        scaleX: 0.85,
      },
      pointWide: {
        y: 43.78877258300781,
        scaleX: 0.95,
      },
      roundNarrow: {
        y: 46.67314910888672,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 44.70989990234375,
        scaleX: 0.9,
      },
      roundWide: {
        y: 43.41850280761719,
        scaleX: 1,
      },
      squareNarrow: {
        y: 44.60308074951172,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 42.920989990234375,
        scaleX: 0.9,
      },
      squareWide: {
        y: 45.51533508300781,
        scaleX: 0.95,
      },
    },
  },
  {
    id: 'Hair68',
    svg: Hair68front,
    positioning: {
      pointNarrow: {
        y: 51.688690185546875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 55.92242431640625,
        scaleX: 1,
      },
      pointWide: {
        y: 49.12968444824219,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 56.70283508300781,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.42372131347656,
        scaleX: 1,
      },
      roundWide: {
        y: 52.88665771484375,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 54.730865478515625,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 49.03413391113281,
        scaleX: 1.05,
      },
      squareWide: {
        y: 51.93244171142578,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'Hair69',
    svg: Hair69front,
    positioning: {
      pointNarrow: {
        y: 53.20697021484375,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 55.33812713623047,
        scaleX: 1,
      },
      pointWide: {
        y: 52.74290466308594,
        scaleX: 1.2,
      },
      roundNarrow: {
        y: 55.91920471191406,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.345054626464844,
        scaleX: 1,
      },
      roundWide: {
        y: 50,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 51.680564880371094,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 51.19263458251953,
        scaleX: 1,
      },
      squareWide: {
        y: 50,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair70',
    svg: Hair70front,
    positioning: {
      pointNarrow: {
        y: 52.567474365234375,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 57.600181579589844,
        scaleX: 1,
      },
      pointWide: {
        y: 46.44346618652344,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 55.288482666015625,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.660728454589844,
        scaleX: 1,
      },
      roundWide: {
        y: 53.46429443359375,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 52.42523193359375,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 52.92506408691406,
        scaleX: 1,
      },
      squareWide: {
        y: 51.25695037841797,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair72',
    svg: Hair72front,
    positioning: {
      pointNarrow: {
        y: 50.90034484863281,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 53.490745544433594,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 56.528961181640625,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 52.55230712890625,
        scaleX: 0.85,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.72142791748047,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 49.736488342285156,
        scaleX: 0.9,
      },
      squareWide: {
        y: 53.3343505859375,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair73',
    svg: Hair73front,
    positioning: {
      pointNarrow: {
        y: 57.16900634765625,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 57.53868865966797,
        scaleX: 1,
      },
      pointWide: {
        y: 48.45521545410156,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 59.78430938720703,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.771827697753906,
        scaleX: 1,
      },
      roundWide: {
        y: 54.87956237792969,
        scaleX: 1,
      },
      squareNarrow: {
        y: 56.02571105957031,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 51.759803771972656,
        scaleX: 1,
      },
      squareWide: {
        y: 51.95582580566406,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair74',
    svg: Hair74,
    positioning: {
      pointNarrow: {
        y: 53.402984619140625,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 58.283599853515625,
        scaleX: 1,
      },
      pointWide: {
        y: 50.823699951171875,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 58.671875,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 59.842674255371094,
        scaleX: 1,
      },
      roundWide: {
        y: 56.356689453125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 57.67229461669922,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 54.554115295410156,
        scaleX: 1,
      },
      squareWide: {
        y: 52.403839111328125,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair75',
    svg: Hair75front,
    positioning: {
      pointNarrow: {
        y: 51.73577880859375,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 52.9132080078125,
        scaleX: 0.85,
      },
      pointWide: {
        y: 50,
        scaleX: 1,
      },
      roundNarrow: {
        y: 55.48948669433594,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 54.650840759277344,
        scaleX: 0.85,
      },
      roundWide: {
        y: 50,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.16764831542969,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 50.36185073852539,
        scaleX: 0.85,
      },
      squareWide: {
        y: 53.17454528808594,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair76',
    svg: Hair76front,
    positioning: {
      pointNarrow: {
        y: 52.546356201171875,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 56.80271911621094,
        scaleX: 1,
      },
      pointWide: {
        y: 50,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 57.682655334472656,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.639122009277344,
        scaleX: 0.95,
      },
      roundWide: {
        y: 55.058380126953125,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 53.49256896972656,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 54.226280212402344,
        scaleX: 1,
      },
      squareWide: {
        y: 50.90869140625,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair77',
    svg: Hair77front,
    positioning: {
      pointNarrow: {
        y: 46.829986572265625,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 53.195213317871094,
        scaleX: 1,
      },
      pointWide: {
        y: 43.47431182861328,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 56.0306396484375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 52.95109558105469,
        scaleX: 0.95,
      },
      roundWide: {
        y: 45.72767639160156,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 50,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50.623992919921875,
        scaleX: 1.05,
      },
      squareWide: {
        y: 52.11206817626953,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair78',
    svg: Hair78front,
    positioning: {
      pointNarrow: {
        y: 50.246002197265625,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 55.31639099121094,
        scaleX: 1,
      },
      pointWide: {
        y: 49.31492614746094,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 57.44541931152344,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 55.48444366455078,
        scaleX: 1,
      },
      roundWide: {
        y: 51.81103515625,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 50,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 47.09979248046875,
        scaleX: 1,
      },
      squareWide: {
        y: 49.05474090576172,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair79',
    svg: Hair79,
    positioning: {
      pointNarrow: {
        y: 27.615798950195312,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 26.757423400878906,
        scaleX: 1,
      },
      pointWide: {
        y: 25.04113006591797,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 28.2886962890625,
        scaleX: 1,
      },
      roundMedium: {
        y: 28.432998657226562,
        scaleX: 1.05,
      },
      roundWide: {
        y: 30.050697326660156,
        scaleX: 1,
      },
      squareNarrow: {
        y: 29.81151580810547,
        scaleX: 1,
      },
      squareMedium: {
        y: 26.91309356689453,
        scaleX: 1,
      },
      squareWide: {
        y: 25.99720001220703,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair80',
    svg: Hair80front,
    positioning: {
      pointNarrow: {
        y: 53.41725158691406,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 57.34357452392578,
        scaleX: 0.95,
      },
      pointWide: {
        y: 50,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 56.134368896484375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 53.029319763183594,
        scaleX: 1,
      },
      roundWide: {
        y: 54.41908264160156,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 53.13677978515625,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 52.50669860839844,
        scaleX: 1,
      },
      squareWide: {
        y: 53.016273498535156,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair81',
    svg: Hair81front,
    positioning: {
      pointNarrow: {
        y: 51.71490478515625,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 52.08390808105469,
        scaleX: 1,
      },
      pointWide: {
        y: 48.35969543457031,
        scaleX: 1,
      },
      roundNarrow: {
        y: 50,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 50.407310485839844,
        scaleX: 0.95,
      },
      roundWide: {
        y: 50.05540466308594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 50.72840881347656,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 45.88482666015625,
        scaleX: 1,
      },
      squareWide: {
        y: 50.506805419921875,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair82',
    svg: Hair82,
    positioning: {
      pointNarrow: {
        y: 60.35957336425781,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 60.756622314453125,
        scaleX: 1.1,
      },
      pointWide: {
        y: 58.91204833984375,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 60.4405517578125,
        scaleX: 1,
      },
      roundMedium: {
        y: 61.446624755859375,
        scaleX: 1.05,
      },
      roundWide: {
        y: 62.35441589355469,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 60.517982482910156,
        scaleX: 1,
      },
      squareMedium: {
        y: 60.76588439941406,
        scaleX: 1.1,
      },
      squareWide: {
        y: 60.99371337890625,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair83',
    svg: Hair83,
    positioning: {
      pointNarrow: {
        y: 52.709320068359375,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 57.52739715576172,
        scaleX: 1.05,
      },
      pointWide: {
        y: 54.53123474121094,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 55.17351531982422,
        scaleX: 1,
      },
      roundMedium: {
        y: 56.470245361328125,
        scaleX: 1.05,
      },
      roundWide: {
        y: 55.82536315917969,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 54.29508972167969,
        scaleX: 1,
      },
      squareMedium: {
        y: 52.929969787597656,
        scaleX: 1.1,
      },
      squareWide: {
        y: 53.78326416015625,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair84',
    svg: Hair84,
    positioning: {
      pointNarrow: {
        y: 58.453094482421875,
        scaleX: 1,
      },
      pointMedium: {
        y: 60.427330017089844,
        scaleX: 1.05,
      },
      pointWide: {
        y: 56.40013122558594,
        scaleX: 1.25,
      },
      roundNarrow: {
        y: 57.366737365722656,
        scaleX: 1,
      },
      roundMedium: {
        y: 58.61835479736328,
        scaleX: 1.1,
      },
      roundWide: {
        y: 57.32905578613281,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 57.002845764160156,
        scaleX: 1,
      },
      squareMedium: {
        y: 55.435089111328125,
        scaleX: 1.1,
      },
      squareWide: {
        y: 59.15629577636719,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair85',
    svg: Hair85,
    positioning: {
      pointNarrow: {
        y: 56.38238525390625,
        scaleX: 1,
      },
      pointMedium: {
        y: 57.40338897705078,
        scaleX: 1.1,
      },
      pointWide: {
        y: 53.88575744628906,
        scaleX: 1.25,
      },
      roundNarrow: {
        y: 56.8856201171875,
        scaleX: 1,
      },
      roundMedium: {
        y: 52.18855285644531,
        scaleX: 1.1,
      },
      roundWide: {
        y: 57.786407470703125,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 54.31621551513672,
        scaleX: 1,
      },
      squareMedium: {
        y: 51.50292205810547,
        scaleX: 1.1,
      },
      squareWide: {
        y: 52.032081604003906,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair86',
    svg: Hair86,
    positioning: {
      pointNarrow: {
        y: 55.15606689453125,
        scaleX: 1,
      },
      pointMedium: {
        y: 58.655128479003906,
        scaleX: 1.1,
      },
      pointWide: {
        y: 55.06892395019531,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 55.17352294921875,
        scaleX: 1,
      },
      roundMedium: {
        y: 54.24908447265625,
        scaleX: 1.1,
      },
      roundWide: {
        y: 55.904541015625,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 53.783729553222656,
        scaleX: 1,
      },
      squareMedium: {
        y: 50.22350311279297,
        scaleX: 1.1,
      },
      squareWide: {
        y: 51.06858825683594,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair87',
    svg: Hair87,
    positioning: {
      pointNarrow: {
        y: 66.77311706542969,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 66.72014617919922,
        scaleX: 1.1,
      },
      pointWide: {
        y: 68.05778503417969,
        scaleX: 1.25,
      },
      roundNarrow: {
        y: 67.58306121826172,
        scaleX: 1,
      },
      roundMedium: {
        y: 67.73560333251953,
        scaleX: 1.1,
      },
      roundWide: {
        y: 65.6346206665039,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 66.0435562133789,
        scaleX: 1,
      },
      squareMedium: {
        y: 67.48407745361328,
        scaleX: 1.1,
      },
      squareWide: {
        y: 67.14081573486328,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair88',
    svg: Hair88,
    positioning: {
      pointNarrow: {
        y: 52.61454772949219,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 56.31111145019531,
        scaleX: 1,
      },
      pointWide: {
        y: 52.90419006347656,
        scaleX: 1,
      },
      roundNarrow: {
        y: 54.63391876220703,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 54.82453155517578,
        scaleX: 1,
      },
      roundWide: {
        y: 55.71559143066406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 52.89103698730469,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 50.65258026123047,
        scaleX: 0.95,
      },
      squareWide: {
        y: 52.59984588623047,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair89',
    svg: Hair89,
    positioning: {
      pointNarrow: {
        y: 61.11224365234375,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 59.84956359863281,
        scaleX: 1.05,
      },
      pointWide: {
        y: 59.143218994140625,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 61.101165771484375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 60.38835906982422,
        scaleX: 1,
      },
      roundWide: {
        y: 61.99296569824219,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 59.724578857421875,
        scaleX: 1,
      },
      squareMedium: {
        y: 61.325103759765625,
        scaleX: 1,
      },
      squareWide: {
        y: 61.88154602050781,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair90',
    svg: Hair90,
    positioning: {
      pointNarrow: {
        y: 59.0565185546875,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 59.384849548339844,
        scaleX: 1.1,
      },
      pointWide: {
        y: 56.85731506347656,
        scaleX: 1.25,
      },
      roundNarrow: {
        y: 60.848106384277344,
        scaleX: 1,
      },
      roundMedium: {
        y: 59.252708435058594,
        scaleX: 1.05,
      },
      roundWide: {
        y: 58.21836853027344,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 58.10588836669922,
        scaleX: 1,
      },
      squareMedium: {
        y: 57.599266052246094,
        scaleX: 1.05,
      },
      squareWide: {
        y: 59.09870147705078,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair91',
    svg: Hair91,
    positioning: {
      pointNarrow: {
        y: 51.59165954589844,
        scaleX: 1,
      },
      pointMedium: {
        y: 54.90425109863281,
        scaleX: 1.1,
      },
      pointWide: {
        y: 53.03882598876953,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 54.74713897705078,
        scaleX: 1,
      },
      roundMedium: {
        y: 50.142982482910156,
        scaleX: 1.05,
      },
      roundWide: {
        y: 54.73182678222656,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 50.39147186279297,
        scaleX: 1,
      },
      squareMedium: {
        y: 51.61163330078125,
        scaleX: 1.05,
      },
      squareWide: {
        y: 50.67414093017578,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair92',
    svg: Hair92,
    positioning: {
      pointNarrow: {
        y: 52.95037841796875,
        scaleX: 1,
      },
      pointMedium: {
        y: 54.725135803222656,
        scaleX: 1.1,
      },
      pointWide: {
        y: 51.60002899169922,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 54.391090393066406,
        scaleX: 1,
      },
      roundMedium: {
        y: 51.6273193359375,
        scaleX: 1.1,
      },
      roundWide: {
        y: 50,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 50.7960205078125,
        scaleX: 1,
      },
      squareMedium: {
        y: 50.69305419921875,
        scaleX: 1.1,
      },
      squareWide: {
        y: 50.814788818359375,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair93',
    svg: Hair93,
    positioning: {
      pointNarrow: {
        y: 55.015594482421875,
        scaleX: 1,
      },
      pointMedium: {
        y: 55.820281982421875,
        scaleX: 1.1,
      },
      pointWide: {
        y: 52.742828369140625,
        scaleX: 1.4,
      },
      roundNarrow: {
        y: 57.375709533691406,
        scaleX: 1,
      },
      roundMedium: {
        y: 53.240325927734375,
        scaleX: 1.1,
      },
      roundWide: {
        y: 50,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 52.221221923828125,
        scaleX: 1,
      },
      squareMedium: {
        y: 53.43634033203125,
        scaleX: 1.1,
      },
      squareWide: {
        y: 53.238616943359375,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair94',
    svg: Hair94,
    positioning: {
      pointNarrow: {
        y: 59.61994934082031,
        scaleX: 1,
      },
      pointMedium: {
        y: 59.08690643310547,
        scaleX: 1.1,
      },
      pointWide: {
        y: 58.22871398925781,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 59.25067138671875,
        scaleX: 1,
      },
      roundMedium: {
        y: 58.251258850097656,
        scaleX: 1.05,
      },
      roundWide: {
        y: 58.77250671386719,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 57.190582275390625,
        scaleX: 1,
      },
      squareMedium: {
        y: 58.437896728515625,
        scaleX: 1.1,
      },
      squareWide: {
        y: 58.69237518310547,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair95',
    svg: Hair95front,
    positioning: {
      pointNarrow: {
        y: 50,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 52.964134216308594,
        scaleX: 1,
      },
      pointWide: {
        y: 47.59349060058594,
        scaleX: 1,
      },
      roundNarrow: {
        y: 52.391845703125,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 49.296302795410156,
        scaleX: 0.95,
      },
      roundWide: {
        y: 49.0260009765625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 54.09288024902344,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 45.70002746582031,
        scaleX: 0.9,
      },
      squareWide: {
        y: 49.84412384033203,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair96',
    svg: Hair96,
    positioning: {
      pointNarrow: {
        y: 59.52018737792969,
        scaleX: 1,
      },
      pointMedium: {
        y: 59.03492736816406,
        scaleX: 1.1,
      },
      pointWide: {
        y: 58.457427978515625,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 59.18482971191406,
        scaleX: 1,
      },
      roundMedium: {
        y: 60.19458770751953,
        scaleX: 1.1,
      },
      roundWide: {
        y: 60.56536865234375,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 58.511741638183594,
        scaleX: 1,
      },
      squareMedium: {
        y: 58.495277404785156,
        scaleX: 1.1,
      },
      squareWide: {
        y: 60.168434143066406,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair97',
    svg: Hair97front,
    positioning: {
      pointNarrow: {
        y: 54.380828857421875,
        scaleX: 1,
      },
      pointMedium: {
        y: 52.746788024902344,
        scaleX: 1.05,
      },
      pointWide: {
        y: 55.02879333496094,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 53.453269958496094,
        scaleX: 1,
      },
      roundMedium: {
        y: 55.16875457763672,
        scaleX: 1.1,
      },
      roundWide: {
        y: 58.76820373535156,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 55.319435119628906,
        scaleX: 1,
      },
      squareMedium: {
        y: 52.38639831542969,
        scaleX: 1.1,
      },
      squareWide: {
        y: 54.01661682128906,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair98',
    svg: Hair98front,
    positioning: {
      pointNarrow: {
        y: 57.212562561035156,
        scaleX: 1,
      },
      pointMedium: {
        y: 56.73741149902344,
        scaleX: 1.1,
      },
      pointWide: {
        y: 58.254127502441406,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 57.598968505859375,
        scaleX: 1,
      },
      roundMedium: {
        y: 59.04425048828125,
        scaleX: 1.2,
      },
      roundWide: {
        y: 57.84028625488281,
        scaleX: 1.3,
      },
      squareNarrow: {
        y: 55.189537048339844,
        scaleX: 1,
      },
      squareMedium: {
        y: 57.93939208984375,
        scaleX: 1.2,
      },
      squareWide: {
        y: 57.659950256347656,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair99',
    svg: Hair99,
    positioning: {
      pointNarrow: {
        y: 59.265350341796875,
        scaleX: 1,
      },
      pointMedium: {
        y: 58.802589416503906,
        scaleX: 1.1,
      },
      pointWide: {
        y: 59.282623291015625,
        scaleX: 1.4,
      },
      roundNarrow: {
        y: 59.25550842285156,
        scaleX: 1,
      },
      roundMedium: {
        y: 58.54515838623047,
        scaleX: 1.1,
      },
      roundWide: {
        y: 58.38279724121094,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 58.079627990722656,
        scaleX: 1,
      },
      squareMedium: {
        y: 60.92247772216797,
        scaleX: 1.1,
      },
      squareWide: {
        y: 60.125885009765625,
        scaleX: 1.3,
      },
    },
  },
]

export default data
